// Copyright (c) 2018 Comsearch, Inc., All rights reserved

// NOTE - status string values are hard coded here.

// these values do not reflect their status id.
// this allows us to sort the statuses, ordering them by their importance.
const statusMap = {
  active: 1,
  inactive: 2,
  invalid: 3,
}

const statusMapper = v => statusMap[v.toLowerCase()] || null

export default statusMapper
